import { useEffect, useState } from 'react';

const useAlert = () => {
  const [showAlert, setShowAlert] = useState(false);

  const [alertData, setAlertData] = useState({
    titleText: '',
    alertText: '',
  });
  const [onCloseCallback, setOnCloseCallback] = useState(() => () => {});

  const preloadImages = (srcArray) => {
    srcArray.forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  };
  
  useEffect(() => {
    preloadImages(['images/warning.gif', 'images/success-2.gif']);
  }, []);

  const showAlertMessage = (message, title, callback) => {
    setAlertData({ titleText: title, alertText: message });
    setOnCloseCallback(() => callback); 
    setShowAlert(true);
  };

  const closeAlert = () => {
    setShowAlert(false);
    if (onCloseCallback) {
      onCloseCallback(); 
    }
  };

  return { showAlert, alertData, showAlertMessage, closeAlert };
};

export default useAlert;
